import React, { useEffect, useState } from "react";
import { useFormik, Field, FormikProvider } from "formik";
import { gettingStartedForm } from "../../schemas/formSchemas";
import BreadCrumbs from "../../reuseable/BreadCrumbs";

import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import SkeletonLoader from "../../reuseable/SkeletonLoader";
import SmartPhoneInput from "../../reuseable/SmartPhoneInput";
import EmailInput from "../../reuseable/EmailInput";
import { handlePhoneChange } from "../../../utils/phoneUtils";
import { toast } from "react-toastify";

const GetStartedForm = () => {
  const [recaptchaValue, setRecaptchaValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [submissionStatus, setSubmissionStatus] = useState(null);

  const formik = useFormik({
    initialValues: {
      childName: "",
      dob: "",
      gender: "",
      relation: "",
      parentName: "",
      phoneNumber: "",
      email: "",
      schoolName: "",
      howdoyouknow: "",
      reason: "",
      captcha: "",
    },
    validationSchema: gettingStartedForm,
    onSubmit: (values, actions) => {
      actions.resetForm();
    },
  });

  const handleRecaptcha = (value) => {
    setRecaptchaValue(value);
    formik.setFieldValue("captcha", value);
  };

  useEffect(() => {
    if (submissionStatus === "success") {
      toast.success("Form submitted successfully!", {
        position: "top-center",
        className: "text-white",
      });
    } else if (submissionStatus === "error") {
      toast.error(
        "There was an error submitting the form. Please contact admin.",
        {
          position: "top-center",
          className: "text-red-500 bg-white",
        }
      );
    }
  }, [submissionStatus]);

  return (
    <>
      <div className="md:ml-14 md:pt-5">
        <BreadCrumbs />
      </div>
      {loading ? (
        <>
          <SkeletonLoader itemCount={8} />{" "}
        </>
      ) : (
        <div className="flex items-center justify-center p-5 lg:p-12 HeroBg2">
          <div className="mx-auto max-w-[650px] lg:max-w-[80%] bg-gray-200 rounded-3xl p-5 md:p-10">
            <FormikProvider value={formik}>
              <form onSubmit={formik.handleSubmit}>
                <h1 className="text-center font-black text-4xl text-blue-950 pb-4">
                  Getting Started
                </h1>
                <div className="mb-5 pt-3">
                  <label className="mb-5 block text-lg font-black text-[#07074D] ">
                    Child Information
                  </label>
                  <div className="-mx-3 flex flex-wrap">
                    {/* Child Name */}
                    <div className="w-full px-3 sm:w-1/2 ">
                      <div className="mb-5">
                        <label className="mb-3 block text-base font-medium text-[#07074D]">
                          Child Name<span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          id="childName"
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          value={formik.values.childName}
                          placeholder="Child Name"
                          disabled={loading}
                          className={`${formik.errors.childName && formik.touched.childName
                            ? "border border-red-600"
                            : " "
                            } w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md`}
                        />
                        {formik.errors.childName && formik.touched.childName && (
                          <p className="text-sm font-semibold text-red-500">
                            {formik.errors.childName}
                          </p>
                        )}
                      </div>
                    </div>
                    {/* Date of birth */}
                    <div className="w-full px-3 sm:w-1/2 ">
                      <label className="mb-3 block text-base font-medium text-[#07074D]">
                        Date of Birth<span className="text-red-500">*</span>
                      </label>
                      <div className="mb-5">
                        <input
                          type="date"
                          id="dob"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.dob}
                          placeholder="D.O.B"
                          disabled={loading}
                          className={`${formik.errors.dob && formik.touched.dob
                            ? "border border-red-600"
                            : ""
                            } w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md`}
                        />
                        {formik.errors.dob && formik.touched.dob ? (
                          <p className="text-sm font-semibold text-red-500">
                            {formik.errors.dob}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    {/* child gender */}
                    <div className="w-full px-3 sm:w-1/2 ">
                      <label className="mb-3 block text-base font-medium text-[#07074D]">
                        Child Gender
                        <span className="text-red-500">*</span>
                      </label>
                      <div className="mb-5">
                        <select
                          id="gender"
                          onChange={formik.handleChange}
                          value={formik.values.gender}
                          onBlur={formik.handleBlur}
                          disabled={loading}
                          className={`${formik.errors.gender && formik.touched.gender
                            ? "border border-red-600"
                            : ""
                            } w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md`}
                        >
                          <option>Select An Option</option>
                          <option>Male</option>
                          <option>Female</option>
                        </select>
                        {formik.errors.gender && formik.touched.gender ? (
                          <p className="text-sm font-semibold text-red-500">
                            {formik.errors.gender}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    <div className="w-full px-3 sm:w-1/2 ">
                      <label className="mb-3 block text-base font-medium text-[#07074D]">
                        Relationship With Child
                        <span className="text-red-500">*</span>
                      </label>
                      <div className="mb-5">
                        <select
                          id="relation"
                          onChange={formik.handleChange}
                          value={formik.values.relation}
                          onBlur={formik.handleBlur}
                          disabled={loading}
                          className={`${formik.errors.relation && formik.touched.relation
                            ? "border border-red-600"
                            : ""
                            } w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md`}
                        >
                          <option>Select An Option</option>
                          <option>Father</option>
                          <option>Mother</option>
                          <option>Guardian</option>
                          <option>Other</option>
                        </select>
                        {formik.errors.relation && formik.touched.relation ? (
                          <p className="text-sm font-semibold text-red-500">
                            {formik.errors.relation}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="w-full px-3 sm:w-1/2 mb-5">
                      <label
                        htmlFor="name"
                        className="mb-3 block text-base font-medium text-[#07074D]"
                      >
                        Name of the Parents/Guardian
                        <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        id="parentName"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.parentName}
                        placeholder="Name of the Parents/Guardian"
                        disabled={loading}
                        className={`${formik.errors.parentName && formik.touched.parentName
                          ? "border border-red-600"
                          : ""
                          } w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md`}
                      />
                      {formik.errors.parentName && formik.touched.parentName ? (
                        <p className="text-sm font-semibold text-red-500">
                          {formik.errors.parentName}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="w-full px-3 sm:w-1/2 mb-5">
                      <label
                        htmlFor="phoneNumber"
                        className="mb-3 block text-base font-medium text-[#07074D]"
                      >
                        Phone Number<span className="text-red-500">*</span>
                      </label>
                      <div className="w-full">
                        <Field
                          name="phoneNumber"
                          component={SmartPhoneInput}
                          placeholder="Phone Number"
                          onChange={(phone, country, e, formattedValue) => handlePhoneChange(phone, country, e, formattedValue, formik, "phoneNumber")}
                        />
                      </div>
                    </div>
                    <div className="w-full px-3 sm:w-1/2 mb-5">
                      <label
                        htmlFor="email"
                        className="mb-3 block text-base font-medium text-[#07074D]"
                      >
                        Email Address<span className="text-red-500">*</span>
                      </label>
                      <Field
                        name="email"
                        component={EmailInput}
                        placeholder="Enter your email"
                      />
                    </div>
                    <div className="w-full px-3 sm:w-1/2 mb-5">
                      <label
                        htmlFor="schoolName"
                        className="mb-3 block text-base font-medium text-[#07074D]"
                      >
                        Child's Current School (if attending)
                        <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        id="schoolName"
                        onChange={formik.handleChange}
                        value={formik.values.schoolName}
                        placeholder="School Name"
                        disabled={loading}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
                      />
                    </div>
                    <div className="w-full px-3 sm:w-1/2 mb-5">
                      <label
                        htmlFor="howdoyouknow"
                        className="mb-3 block text-base font-medium text-[#07074D]"
                      >
                        How do you know about us:{" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <select
                        id="howdoyouknow"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.howdoyouknow}
                        disabled={loading}
                        className={`${formik.touched.howdoyouknow &&
                          formik.errors.howdoyouknow
                          ? "border border-red-600"
                          : ""
                          }  w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md`}
                      >
                        <option>Select An Option</option>
                        <option>ELiNA Website</option>
                        <option>Social Media</option>
                        <option>Through HLC</option>
                        <option>Through other schools</option>
                        <option>Through other parents</option>
                        <option>Through friends</option>
                        <option>Through my therapists</option>
                        <option>Others</option>
                      </select>
                      {formik.errors.howdoyouknow &&
                        formik.touched.howdoyouknow ? (
                        <p className="text-sm font-semibold text-red-500">
                          {formik.errors.howdoyouknow}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="w-full px-3 sm:w-1/2 mb-5">
                      <label
                        htmlFor="reason"
                        className="mb-3 block text-base font-medium text-[#07074D]"
                      >
                        Reason for Contacting Us
                        <span className="text-red-500">*</span>
                      </label>
                      <textarea
                        id="reason"
                        onChange={formik.handleChange}
                        value={formik.values.reason}
                        disabled={loading}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
                      />
                    </div>
                  </div>
                </div>
                <div id="captcha" className="">
                  <ReCAPTCHA
                    sitekey="6LcfLFUoAAAAACno3hdClnckkDsl4ERrkfhX7Alr"
                    onChange={handleRecaptcha}
                  />
                  {formik.errors.captcha && formik.touched.captcha ? (
                    <p className="text-sm font-semibold text-red-500">
                      {formik.errors.captcha}
                    </p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="flex justify-end">
                  <button
                    type="submit"
                    disabled={loading}
                    className="hover:shadow-form w-full md:w-[40%] mt-5 rounded-md bg-blue-950 border-blue-950 hover:border-blue-950 hover:text-blue-950 py-3 px-8 text-center text-base font-semibold text-white outline-none"
                  >
                    {loading ? "Submitting..." : "Submit"}
                  </button>
                </div>
                {/* {submissionStatus === "success" && (
                <div className="mt-5 text-green-500 text-center">
                  Form submitted successfully!
                </div>
              )}
              {submissionStatus === "error" && (
                <div className="mt-5 text-red-500 text-center">
                  There was an error submitting the form. Please contact admin.
                </div>
              )} */}
              </form>
            </FormikProvider>
          </div>
        </div>
      )}
    </>
  );
};

export default GetStartedForm;
